<template>
  <lf-base-dialog
    v-if="visible"
    v-model="visible"
    :title="deviceName"
    size="large"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    cancel-button-text="关闭"
    :show-confirm-button="false"
    @cancel="() => visible = false"
    @closed="handleClose"
  >
    <div
      v-if="activeVideo&&videoList.length>0"
      v-loading="loading"
    >
      <el-radio-group
        v-model="activeVideo"
        style="max-height: 200px;overflow-y: auto ;"
        @change="(val) => handleCameraChange(val as string)"
      >
        <el-radio-button
          v-for="item in videoList"
          :key="item.code"
          :label="item.name"
          :value="item.code"
        />
      </el-radio-group>
      <div
        class="play-area"
      >
        <lfBaseVideo
          ref="lfBaseVideoRef"
          :camera-id="activeVideo"
        />
      </div>
    </div>
    <div v-else>
      <el-empty description="空间下未查询到摄像头" />
    </div>
  </lf-base-dialog>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';
  import { FormInstance } from 'element-plus';
  import lfBaseVideo from '@/components/lf-base-video';
  import { useDebounceFn } from '@vueuse/core';
  import { getCameraList } from '@/api/modules/ibms';
  import { useOrgStore } from '@/store/org';

  const visible = ref(false);

  const activeVideo = ref('');

  const lfBaseVideoRef = ref();

  const cameraId = ref('1');

  const deviceName = ref('');

  const videoList = ref<{ code: string, name: string }[]>([]);

  const orgStore: any = useOrgStore();
  const orgId = computed(() => orgStore.currentOrgInfo.orgId);
  const loading = ref(false);

  const getCameraListRequest = (id: string) => {
    loading.value = true;
    if (id) {
      getCameraList({
        equipCode: id,
        orgId: orgId.value,
      }).then((res) => {
        videoList.value = res.data;
        if (videoList.value.length > 0) {
          activeVideo.value = videoList.value[0].code;
        }
      }).finally(() => {
        loading.value = false;
      });
    } else {
      videoList.value = [];
    }
  };

  const handleCameraChange = useDebounceFn((val: string) => {
    cameraId.value = val;
  }, 500);

  const handleOpenDialog = (id: string, name: string) => {
    console.log('handleOpenDialog', id, name);
    visible.value = true;
    deviceName.value = name;
    getCameraListRequest(id);
  };

  const handleClose = () => {
    deviceName.value = '';
    activeVideo.value = '';
    videoList.value = [];
  };

  const handleConfirm = (formEl: FormInstance | undefined) => {
    if (!formEl) { return; }
    formEl.validate((valid) => {
      if (!valid) {
        return;
      }
      console.log(1);
    });
  };

  defineExpose({
    handleOpenDialog,
  });

</script>

<style scoped lang="scss">
.ma-radio-group {
  display: flex;
  gap: 12px;

  :deep(.ma-radio-button .ma-radio-button__inner) {
    border: var(--ma-border);
    border-radius: 25px;
    box-shadow: none;
  }
}

.play-area {
  display: flex;
  justify-content: space-between;
  height: 500px;
  margin-top: 16px;

  .play-area-video {
    width: 70%;
  }

  .play-area-search {
    width: 30%;
    margin-left: 12px;
  }

  .play-area-search-tip {
    margin-bottom: 12px;
    color: var(--ma-color-danger);
  }

  .btns button {
    width: 47.6%;
  }
}
</style>
